interface SeoInterface {
   title: string | undefined;
   image?: string;
   description?: string;
}
export const useSeoHelper = (page: SeoInterface) => {
   const $urlFor = useNuxtApp().$urlFor;
   const image = computed(() => page?.image);

   const description = computed(() => page?.description ?? "");
   const title = computed(() => page?.title ?? "Juilliard Creative Classroom");

   useSeoMeta({
      title: title.value,
      ogTitle: title.value,
      description: description.value,
      ogDescription: description.value,
      ogImage: image.value,
   });
};
